import PropTypes from 'prop-types';
import React from 'react';
import FormPropTypes from 'redux-form/lib/propTypes';
import { t } from '../../../../modules/infra/i18n';
import Select from '../../../common/select';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';
import CurrencyInput from '../../../common/currencyInput';
import Input from '../../../common/input';
import SubscriptionPaymentCard from '../containers/SubscriptionPaymentCard';

const SubscriptionForm = ({
  submitting,
  handleSubmit,
  currency,
  subscriptionPlans,
  chargeSubscription,
  hasSubscription,
  canEditIndyCustomAppAddon,
}) => (
  <div>
    <SubscriptionPaymentCard display-if={hasSubscription || chargeSubscription} />
    <form onSubmit={handleSubmit}>
      <div className="layout u-mt">
        <div className="layout__item u-1/2">
          <div className="c-label-new">{t('subscription:plan_label')}</div>
          <Select
            name="subscriptionPlanId"
            empty={t('subscription:select_plan_placeholder')}
            className="c-select"
            options={subscriptionPlans.map(plan => ({
              label: plan.name,
              value: plan.id,
            }))}
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="enabled"
            label={t('subscription:activate_subscription_label')}
            id="enabled"
            wrapperClass="u-mt-"
          />
        </div>
        <div className="layout__item u-1/2" display-if={chargeSubscription}>
          <div className="c-label-new">{t('subscription:price_per_location_label')}</div>
          <CurrencyInput
            className="c-input"
            placeholder={t('subscription:price_per_location_label')}
            name="price"
            currency={currency}
            useIsoCurrencyCode
          />
        </div>
        <div className="layout__item u-1/2" display-if={chargeSubscription}>
          <div className="c-label-new">{t('subscription:number_of_locations_label')}</div>
          <Input
            className="c-input"
            name="quantity"
            type="number"
            placeholder="0"
          />
        </div>
        <div className="layout__item u-mt- u-mb u-type--semibold" display-if={chargeSubscription}>
          {t('subscription:add_ons_label')}
          <div className="u-mt--">
            <CheckboxSwitch
              name="indyCustomAppAddon"
              label={t('subscription:custom_indy_app_label')}
              id="indyCustomAppAddon"
              wrapperClass="u-1/2"
              disabled={!canEditIndyCustomAppAddon}
            />
          </div>
        </div>
        <div className="layout__item">
          <AdminSaveButton disabled={submitting} content={t('brand:form.save_button')} />
        </div>
      </div>
    </form>
  </div>
);

SubscriptionForm.propTypes = {
  ...FormPropTypes,
  coupons: PropTypes.arrayOf(PropTypes.object),
  hasSubscription: PropTypes.boolean,
  canEditIndyCustomAppAddon: PropTypes.boolean,
};

SubscriptionForm.defaultProps = {
  coupons: [],
  hasSubscription: false,
  canEditIndyCustomAppAddon: false,
};

export default SubscriptionForm;
